import {useNavigation} from '@react-navigation/native';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {Flows, ScreenName} from 'navigations/Screens';
import {createNavigationAdmin} from 'navigations/TabBar';
import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import styleSheet from './styles';

interface TabModel {
  name: string;
  tabTitle: string;
}

export interface NavigationHeaderWebProps {
  activeName: Flows | ScreenName;
  renderItem?: (index: number, name: string, tabTitle: string) => JSX.Element;
  navigationStack?: TabModel[];
  screenParams?: object;
  backgroundColor?: object;
  sessionId?: string;
}

const NavigationHeaderWebTabs = observer((props: NavigationHeaderWebProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const navigationStack = props.navigationStack
    ? props.navigationStack
    : createNavigationAdmin(theme);

  const navigation = useNavigation();

  const adminItem = (index: number, name: string, tabTitle: string) => {
    return (
      <TouchableOpacity
        key={index}
        style={styles.itemContainer}
        onPress={() =>
          navigation.navigate(
            name as never,
            {
              id: props.sessionId,
            } as never,
          )
        }>
        <Text style={styles.text}>{tabTitle}</Text>
        {props.activeName == name && <View style={styles.activeLine} />}
      </TouchableOpacity>
    );
  };

  const renderItem = props.renderItem ? props.renderItem : adminItem;

  return (
    <View style={[styles.container, props.backgroundColor]}>
      <View style={styles.screensContainer}>
        {navigationStack.map((screen, index) =>
          renderItem(index, screen.name, screen.tabTitle),
        )}
      </View>
    </View>
  );
});

export default NavigationHeaderWebTabs;
